<!-- #region HTML -->
<template>
  <div class="app">
    <div class="main-container form-container">
      <div>
        <!-- #region Complete Check Image -->
        <img class="complete-check" alt="完了" src="@/assets/img/complete-check.svg" width="100%" />
        <!-- #endregion -->

        <!-- #region Complete Title -->
        <div class="complete-title">メールアドレスを変更しました</div>
        <!-- #endregion -->

        <!-- #region Submit Container -->
        <div class="submit-container flex-center">
          <div class="description">
            5秒後にジャンプします。ジャンプしない場合は、<router-link to="/">こちら</router-link>をクリックしてください。
          </div>
        </div>
        <!-- #endregion Submit Container -->
      </div>
    </div>
  </div>
</template>
<!-- #endregion HTML-->

<!-- #region JavaScript -->
<script>
export default {
  name: 'CompleteSignup',
  data() {
    return {
      redirectTimeout: null, 
    };
  },
  created() {
    this.redirectTimeout = setTimeout(() => {
      this.$router.push({ name: 'signin' });
    }, 5000);
  },
  beforeDestroy() {  
    if (this.redirectTimeout) {
      clearTimeout(this.redirectTimeout);
    }
  },
}
</script>

<!-- #endregion -->